var exports = {
  "TS": "x936d19a0--74f9be--rate",
  "yg": "x936d19a0--74f9be--rate_high",
  "cI": "x936d19a0--74f9be--rate_low",
};

module.exports = exports;
